/* eslint-disable camelcase */
import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerUserService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto,
} from '../../services/wealthlane-customer-services';

const useGetCustomerPersonalDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto | undefined,
  unknown
> => {
  const customerPersonalDetails = useQuery(['getParticipantPersonalDetails'], async () => {
    return await handleRequest(CustomerUserService.getApiCustomerApiAppCustomerUserCustomerUser());
  });

  return customerPersonalDetails;
};

export default useGetCustomerPersonalDetails;
